"use strict";
Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _classesModel = require('../classes/Model');

var _classesModel2 = _interopRequireDefault(_classesModel);

var _User = require('./User');

var _User2 = _interopRequireDefault(_User);

var _classesBrowser = require('../classes/Browser');

var _classesBrowser2 = _interopRequireDefault(_classesBrowser);

var _classesSession = require('../classes/Session');

var _classesSession2 = _interopRequireDefault(_classesSession);

var PlaylistTrack = function PlaylistTrack(data) {
    _classCallCheck(this, PlaylistTrack);

    this.added_at = data.added_at;
    this.added_by = data.added_by;
    this.is_local = data.is_local;
    this.track = data.track;
};

var Playlist = (function (_Model) {
    _inherits(Playlist, _Model);

    function Playlist(data) {
        _classCallCheck(this, Playlist);

        _get(Object.getPrototypeOf(Playlist.prototype), 'constructor', this).call(this, data);
        this._owner;
        this._name; //different from rawData to detect changes for save updates
        this._public; //different from rawData to detect changes for save updates
        this._mustUpdate = false;
        this._tracks = new Map();
        this._addedTracks = new Map();
        this._removedTracks = new Map();
        this._reorderedTracks = new Map();
    }

    /**
    * protect attributes from mass assigment
    */

    _createClass(Playlist, [{
        key: '_getUserId',
        value: function _getUserId() {
            return this.owner.id;
        }
    }, {
        key: 'checkOwnerPresence',
        value: function checkOwnerPresence() {
            var _this = this;

            return new Promise(function (resolve, reject) {
                if (!_this.owner.id) {
                    (function () {
                        var playlist = _this;
                        _classesSession2['default'].getCurrentUser().then(function (me) {
                            playlist.owner = me;
                            resolve(me);
                        });
                    })();
                } else {
                    resolve(_this.owner);
                }
            });
        }
    }, {
        key: 'createOrUpdate',
        value: function createOrUpdate() {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                var mustUpdate = _this2._mustUpdate;
                var mustCreate = !_this2.id;
                var action = undefined;
                if (mustCreate) {
                    action = 'create-playlists';
                } else {
                    if (mustUpdate) {
                        action = 'change-playlists';
                    }
                };

                if (action) {
                    _this2.apply(action, { name: _this2.name, 'public': _this2.isPublic }).then(function () {
                        resolve(_this2);
                    });
                } else {
                    resolve(_this2);
                }
            });
        }
    }, {
        key: 'saveTracks',
        value: function saveTracks() {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                var tracksChaned = _this3._trackChanged;
                if (tracksChaned) {
                    _this3.apply('add-playlist-tracks', { uris: _this3.getAddedTracksUris() }).then(function () {
                        resolve(_this3);
                    });
                } else {
                    resolve(_this3);
                }
            });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this4 = this;

            return this.checkOwnerPresence().then(function () {
                _this4.createOrUpdate().then(function () {
                    _this4.saveTracks().then(function () {
                        return _this4;
                    });
                });
            });
        }
    }, {
        key: 'addTracks',
        value: function addTracks(trackList) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = trackList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var track = _step.value;

                    this.addTrack(track);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator['return']) {
                        _iterator['return']();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'addTrack',
        value: function addTrack(track) {
            var retVal = false;
            if (!this._tracks.has(track.id)) {
                this._addedTracks.set(track.id, new PlaylistTrack({
                    added_by: this.owner.id,
                    added_at: new Date(),
                    track: track
                }));
                retVal = this._trackChanged = true;
            }
            return retVal;
        }
    }, {
        key: 'removeTrack',
        value: function removeTrack(track) {
            var retVal = false;
            if (this._tracks.has(track.id)) {
                this._removedTracks.set(track.id, track);
                this._tracks['delete'](track.id);
                retVal = this._trackChanged = true;
            }
            if (this._addedTracks.has(track.id)) {
                this._addedTracks['delete'](track.id);
                retVal = true;
            }
            return retVal;
        }
    }, {
        key: 'clearTracks',
        value: function clearTracks() {
            this._tracks.clear();
            this._addedTracks.clear();
            this._trackChanged = true;
        }
    }, {
        key: 'resetTracks',
        value: function resetTracks() {
            this._addedTracks.clear();
            this._removedTracks.clear();
            this._trackChanged = false;
        }
    }, {
        key: 'getAddedTracksUris',
        value: function getAddedTracksUris() {
            var uris = [];

            var _arr = [].concat(_toConsumableArray(this._addedTracks.values()));

            for (var _i = 0; _i < _arr.length; _i++) {
                var playlistTrack = _arr[_i];
                //console.log(playlistTrack);
                uris.push(playlistTrack.track.uri);
            }
            return uris;
        }
    }, {
        key: 'tracks',
        get: function get() {
            if (!this._tracks || this._tracks.size == 0) {
                for (var track in this.rawData.tracks) {
                    track.added_by = new _User2['default'](track.added_by);
                    var playlistTrack = new PlaylistTrack(track);
                    this._tracks.set(playlistTrack.track.id, playlistTrack);
                }
            }
            return [].concat(_toConsumableArray(this._tracks.values()));
        }
    }, {
        key: 'owner',
        get: function get() {
            var data = this.rawData ? this.rawData.owner : {};
            return this._owner || new _User2['default'](data);
        },
        set: function set(value) {
            this._owner = value instanceof _User2['default'] ? value : null;
        }
    }, {
        key: 'name',
        get: function get() {
            return this._name;
        },
        set: function set(value) {
            this._mustUpdate = value != this._name && this._name && this.id;
            this._name = value;
        }
    }, {
        key: 'public',
        get: function get() {
            return this._public;
        },
        set: function set(value) {
            this._mustUpdate = value != this._public && this._public && this.id;
            this._public = value;
        }
    }, {
        key: 'isPublic',
        get: function get() {
            return this['public'] || true;
        }
    }], [{
        key: '_getNotFillable',
        value: function _getNotFillable() {
            return ['artists', 'tracks', 'owner'];
        }
    }, {
        key: '_getType',
        value: function _getType() {
            return 'playlists';
        }
    }, {
        key: 'find',
        value: function find(id) {
            var _this5 = this;

            var user = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

            return new Promise(function (resolve, reject) {
                if (!user) {
                    _classesSession2['default'].getCurrentUser().then(function (me) {
                        var browser = new _classesBrowser2['default']({ id: id, factory: _this5, user_id: me.id });
                        resolve(browser.get());
                    });
                } else {
                    var browser = new _classesBrowser2['default']({ id: id, factory: _this5, user_id: user.id });
                    resolve(browser.get());
                }
            });
        }
    }]);

    return Playlist;
})(_classesModel2['default']);

exports['default'] = Playlist;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/spotify-client/lib/entities/Playlist.js
 ** module id = 284
 ** module chunks = 0
 **/